import React from 'react';
import './Blog.css';

function Blog() {
  return (
    <section className="blog section" id="blog">
      <div className="blog-container">
        <div className="blog-layout">
          <div className="blog-visual">
            <img src="/slide4.png" alt="Viviworks IA" className="blog-visual-image" />
          </div>

          <div className="blog-content-right">
            <div className="blog-header">
              <h2 className="blog-title">Blog / <span>Ressources</span></h2>
              <p className="blog-subtitle">
                Gardez une longueur d'avance sur les tendances IA
              </p>
            </div>

            <div className="blog-cards">
              <div className="blog-card white-card">
                <div>
                  <h3>ARTICLES</h3>
                  <p>
                    À travers notre blog, nous partageons des articles dédiés au digital, au marketing en ligne
                    et aux nouvelles tendances du web et de l'IA. Notre but est d'offrir à nos lecteurs des
                    contenus utiles, pratiques et inspirants.
                  </p>
                </div>
                <button>Découvrir nos articles</button>
              </div>

              <div className="blog-card white-card">
                <div>
                  <h3>GUIDES PRATIQUES</h3>
                  <p>
                    Nos guides pratiques, enrichis par l'intelligence artificielle, vous offrent des stratégies digitales
                    intelligentes et efficaces. Du décryptage des tendances à l'optimisation de votre présence en ligne,
                    l'IA nous permet de partager des conseils fiables et actionnables.
                  </p>
                </div>
                <button>Découvrir nos articles</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-bg"></div>
    </section>
  );
}

export default Blog;

